import { callApi } from '../../../../apiCaller';
import { DEFAULT_FN } from '../../../../constants';
import { toastError } from '../../../../utils';

export const ADD_FILTER_COMPONENT = 'addFilterComponent';
export const CHANGE_FILTER_COMPONENT = 'changeFilterComponent';
export const DELETE_FILTER_COMPONENT = 'deleteFilterComponent';
export const GET_DESIGNATION_ELEMENT_OPTIONS = 'getDesignationElementOptions';
export const CHANGE_SCOPE_OPTIONS = 'changeScopeOptions';
export const ADD_MULTI_FILTER_COMPONENT = 'addMultiFilterComponent';
export const DESIGNATION_ELEMENT_REPORT_RESULTS = 'designationElementReportResults';
export const RESET_DESIGNATION_ELEMENT_REPORTS = 'resetFilterDesignationReports';
export const LOADING_DESIGNATION_REPORTS = 'loadingDesignationReports';
export const SET_PAGINATION_DESIGNATION_REPORTS = 'setPaginationDesignationReports';
export const SET_SORT_DESIGNATION_REPORTS = 'setSortDesignationReports';

const API_FETCH_DESIGNATION_ELEMENT_OPTIONS = 'designation-element/options';
const API_FETCH_DESIGNATION_ELEMENT_REPORTS = 'designation-element/reports';
const API_FETCH_DESIGNATION_ELEMENT_EXPORT_EXCEL = 'designation-element/export-excel';

export const addFilterComponent = (component) => {
     return {
          type: ADD_FILTER_COMPONENT,
          payload: component,
     };
};

export const deleteFilterComponent = (id) => {
     return {
          type: DELETE_FILTER_COMPONENT,
          payload: id,
     };
};

export const changeFilterComponent = (component) => {
     return {
          type: CHANGE_FILTER_COMPONENT,
          payload: component,
     };
};

export const getDesignationElementOptions = (designationElements) => {
     return {
          type: GET_DESIGNATION_ELEMENT_OPTIONS,
          payload: designationElements,
     };
};

export const fetchDesignationElementOptions = (nextDispatch) => (dispatch) => {
     callApi(API_FETCH_DESIGNATION_ELEMENT_OPTIONS, 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               let dataOptions = response.data;

               if (nextDispatch && typeof nextDispatch.multiSelect) {
                    dataOptions = response.data.map((data) => ({
                         value: data.id,
                         label: data.name,
                         key: data.key,
                         level: data.requirementCertificationLevels,
                         access: data.userAccessStatus,
                         isLiveTraining: data.isLiveTraining,
                    }));
               }

               dispatch(getDesignationElementOptions(dataOptions));
          })
          .catch((response) => {
               toastError(response);
          })
          .finally(() => {
               if (nextDispatch && typeof nextDispatch.setIsLoading === 'function') {
                    nextDispatch.setIsLoading(false);
               }
          });
};

export const fetchFilterDesignationReports = (values, nextDispatch) => (dispatch, getState) => {
     const sort = getState().admin.designationReports.sort;

     const { paginationPayload, sortPayload } = nextDispatch;

     const filterQuery = Object.keys(values).length ? JSON.stringify(values) : '';

     const payload = {
          page: paginationPayload.page,
          pageSize: paginationPayload.pageSize,
          sortBy: sortPayload?.sortBy || sort.sortBy,
          sortType: sortPayload?.sortType || sort.sortType,
          filter: filterQuery || undefined,
     };

     dispatch(setLoadingDesignationReports(true));

     callApi(API_FETCH_DESIGNATION_ELEMENT_REPORTS, 'POST', payload)
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               dispatch(designationElementReportResults(response.data));
          })
          .finally(() => {
               dispatch(setLoadingDesignationReports(false));
          });
};

export const changeScopeOptions = (scopeOptions) => {
     return {
          type: CHANGE_SCOPE_OPTIONS,
          payload: scopeOptions,
     };
};

export const addMultiFilterComponent = (filterComponents) => {
     return {
          type: ADD_MULTI_FILTER_COMPONENT,
          payload: filterComponents,
     };
};

export const designationElementReportResults = (results) => {
     return {
          type: DESIGNATION_ELEMENT_REPORT_RESULTS,
          payload: results,
     };
};

export const fetchFilterDesignationExportExcel =
     (values, setIsLoadingExcel = DEFAULT_FN, setIsEmptyExcel = DEFAULT_FN) =>
     (_, getState) => {
          const sort = getState().admin.designationReports.sort;

          const filterQuery = Object.keys(values).length ? JSON.stringify(values) : '';

          const payload = {
               sortBy: sort.sortBy,
               sortType: sort.sortType,
               filter: filterQuery || undefined,
          };

          setIsLoadingExcel(true);

          callApi(API_FETCH_DESIGNATION_ELEMENT_EXPORT_EXCEL, 'POST', payload)
               .then((response) => {
                    if (response.status !== 200) {
                         toastError(response);
                         return;
                    }

                    if (response.data.status) {
                         window.open(response.data.downloadLink);
                    } else {
                         setIsEmptyExcel(response.data);
                    }
               })
               .catch((response) => {
                    toastError(response);
               })
               .finally(() => {
                    setIsLoadingExcel(false);
               });
     };

export const resetFilterDesignationReports = () => {
     return {
          type: RESET_DESIGNATION_ELEMENT_REPORTS,
     };
};

export const setLoadingDesignationReports = (isLoading) => {
     return {
          type: LOADING_DESIGNATION_REPORTS,
          payload: isLoading,
     };
};

export const setPaginationDesignationReports = (pagination) => {
     return {
          type: SET_PAGINATION_DESIGNATION_REPORTS,
          payload: pagination,
     };
};

export const setSortDesignationReports = (sort) => {
     return {
          type: SET_SORT_DESIGNATION_REPORTS,
          payload: sort,
     };
};
